import React, { useEffect, useLayoutEffect, useState } from "react";
import AppRouter from "./routes/AppRouter";
import { ThemeProvider } from "./context/ThemeContext";
import { activeTheme } from "./themes";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "rc-tooltip/assets/bootstrap.css";
import Loader from "./components/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { fetchToken } from "./redux/action/authAction";
import BackToTopArrow from "./components/common/BackToTopArrow";
import useNotifications from "./components/hooks/useNotifications";
import SyncReduxAcrossTabs from "./redux/SyncReduxAcrossTabs";

function App() {
    const dispatch = useDispatch();
    const [tokenVerified, setTokenVerified] = useState(null);
    const lang = useSelector((state) => state.translation.lang);
    useNotifications(); // Custom hook for handle notification service

    useLayoutEffect(() => {
        const oldLink = document.getElementById(`lang-css`);
        const link = document.createElement("link");
        link.id = `lang-css`;
        link.rel = "stylesheet";
        link.href = lang === "en"
            ? `/css/style.${activeTheme.name}.css`
            : `/css/style.${activeTheme.name}.ar.css`;
        link.onload = () => {
            if (oldLink) document.head.removeChild(oldLink);
        };
        document.head.appendChild(link);
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "en" ? "ltr" : "rtl";

        // If anything on the page overflows horizontally, the browser can
        // land the scroll position away from the correct reading start —
        // the left edge in LTR, but the RIGHT edge in RTL. `scrollLeft = 0`
        // is the spec-defined "start" position in both directions, so
        // resetting it here re-anchors the page correctly on every
        // language switch instead of leaving it wherever it happened to be.
        document.documentElement.scrollLeft = 0;
        document.body.scrollLeft = 0;
    }, [lang]);

    useLayoutEffect(() => {
        Promise.all([dispatch(fetchToken())]).then(() => {
            setTokenVerified(true);
        });
        // eslint-disable-next-line
    }, []);

    if (tokenVerified === null) {
        return <Loader />;
    }

    return (
        <ThemeProvider>
            <SyncReduxAcrossTabs />
            <ToastContainer
                theme="colored"
                position="top-right"
                transition={Flip}
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover={false}
                style={{ marginTop: 50 }}
            />
            <AppRouter />
            <Loader />
            <BackToTopArrow />
        </ThemeProvider>
    );
}

export default App;
